/**
 * AppealContentReportContent
 *
 * Mirrors Flutter's ContentReportAppealScreen layout
 * (lib/presentation/screens/content/content_report_appeal_screen.dart).
 * Thin wrapper composing useAppealContentReport with the shared
 * AppealReportContent layout.
 */

import React from 'react';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { AppealReportContent } from '@/presentation/components/common/appealReport/AppealReportContent';
import { useAppealContentReport } from '../hooks/useAppealContentReport';

export interface AppealContentReportContentProps {
  contentId: string;
  onFinish: (submitted: boolean) => void;
}

export const AppealContentReportContent: React.FC<AppealContentReportContentProps> = ({
  contentId,
  onFinish,
}) => {
  const { l10n } = useLocale();

  const { comment, isSubmitting, hasCommentError, setComment, handleSubmit } = useAppealContentReport({
    contentId,
    onFinish,
  });

  return (
    <AppealReportContent
      title={l10n.appealContentReport.title}
      subtitle={l10n.appealContentReport.subtitle}
      description={l10n.appealContentReport.description}
      commentPlaceholder={l10n.appealContentReport.commentPlaceholder}
      emptyCommentError={l10n.appealContentReport.emptyCommentError}
      submitLabel={l10n.appealContentReport.submit}
      comment={comment}
      isSubmitting={isSubmitting}
      hasCommentError={hasCommentError}
      setComment={setComment}
      onClose={() => onFinish(false)}
      onSubmit={handleSubmit}
    />
  );
};
